(function() {
  var ic = document.getElementById('fp-ba-container');
  if (!ic) return;
  var overlay = document.getElementById('fp-ba-overlay');
  var line = document.getElementById('fp-ba-line');
  var handle = document.getElementById('fp-ba-handle');
  var pct = 50, dragging = false, autoDir = 1, timer = null;

  function apply(p) {
    pct = Math.max(0, Math.min(100, p));
    overlay.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    line.style.left = handle.style.left = pct + '%';
  }

  function startAuto() {
    clearInterval(timer);
    timer = setInterval(function() {
      if (dragging) return;
      pct += autoDir * 0.4;
      if (pct >= 95) autoDir = -1;
      if (pct <= 5) autoDir = 1;
      apply(pct);
    }, 16);
  }

  function getP(e) {
    var r = ic.getBoundingClientRect();
    var x = e.touches ? e.touches[0].clientX : e.clientX;
    return ((x - r.left) / r.width) * 100;
  }

  ic.addEventListener('mousedown', function(e) { dragging = true; apply(getP(e)); });
  window.addEventListener('mousemove', function(e) { if (dragging) apply(getP(e)); });
  window.addEventListener('mouseup', function() { if (dragging) { dragging = false; startAuto(); } });
  ic.addEventListener('touchstart', function(e) { dragging = true; apply(getP(e)); }, { passive: true });
  window.addEventListener('touchmove', function(e) { if (dragging) apply(getP(e)); }, { passive: true });
  window.addEventListener('touchend', function() { if (dragging) { dragging = false; startAuto(); } });

  apply(50);
  setTimeout(startAuto, 3000);
})();
